/**
 * The colours a chart may use, in one place.
 *
 * Not from V1's tokens: those name states (error, warning, success), and a
 * series is not a state -- painting "não era problema" in the error red would
 * say something the number does not. These are the first four slots of the
 * dataviz reference palette, in its order, which is what keeps neighbours
 * apart for a colour-blind reader (worst adjacent pair ΔE 9.1 under protanopia,
 * checked with the palette's validator). The third and fourth sit under 3:1
 * against white, so anything drawn in them also carries a written value.
 *
 * A colour belongs to what it stands for, not to its position in a chart: use
 * the same slot for the same thing everywhere on a screen.
 */
export const SERIES = {
  blue: '#2a78d6',
  orange: '#eb6834',
  aqua: '#1baf7a',
  yellow: '#eda100',
} as const

/** For what is still open or was never counted: context, not a series. */
export const RECESSIVE = {
  strong: '#8b8fa3',
  weak: '#d3d6e0',
} as const
